import { IDatePickerStrings } from 'office-ui-fabric-react'

const pad = (input: number) => (input < 10 ? `0${input}` : `${input}`)

export const dateToGraphQLDate = (date?: Date | null) =>
  date
    ? `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`
    : undefined
export const graphQLDateToDate = (graphQLDate?: string | null) =>
  graphQLDate ? new Date(Date.parse(graphQLDate)) : undefined
export const dateTimeToGraphQLDateTime = (date?: Date | null) =>
  date
    ? `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
        date.getDate()
      )}T${pad(date.getHours() - 2)}:${pad(date.getMinutes())}:${pad(
        date.getSeconds()
      )}.00Z`
    : undefined

// 2019-10-15 02:00:00.000

export const DayPickerStrings: IDatePickerStrings = {
  months: [
    'Januar',
    'Februar',
    'März',
    'April',
    'Mai',
    'Juni',
    'Juli',
    'August',
    'September',
    'Oktober',
    'November',
    'Dezember',
  ],

  shortMonths: [
    'Jan',
    'Feb',
    'Mär',
    'Apr',
    'Mai',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Okt',
    'Nov',
    'Dez',
  ],

  days: [
    'Sonntag',
    'Montag',
    'Dienstag',
    'Mittwoch',
    'Donnerstag',
    'Freitag',
    'Samstag',
  ],

  shortDays: ['So.', 'Mo.', 'Di.', 'Mi.', 'Do.', 'Fr.', 'Sa.'],

  goToToday: 'Zu Heute',
  prevMonthAriaLabel: 'Zum vorigen Monat',
  nextMonthAriaLabel: 'Zum nächsten Monat',
  prevYearAriaLabel: 'Zum vorigen Jahr',
  nextYearAriaLabel: 'Zum nächsten Jahr',
  closeButtonAriaLabel: 'Close date picker',

  isRequiredErrorMessage: 'Startdatum ist erforderlich.',

  invalidInputErrorMessage: 'Datumsformat ist invalide.',
}

export const onFormatDate = (date: Date): string => {
  return date.toLocaleDateString('de-DE', {
    timeZone: 'Europe/Berlin',
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hourCycle: 'h24',
  })
}
